import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from '@env/environment';
import { Observable } from 'rxjs';
import { BaseApiResponse } from '../..';
import { IJoinCampaignRequestParams, IJoinCampaignResponse } from './join-campaign.service.types';

@Injectable({
  providedIn: 'root'
})
export class JoinCampaignService {
  constructor(private readonly http: HttpClient) {}

  public joinCampaign(programID: number, params: IJoinCampaignRequestParams): Observable<BaseApiResponse<IJoinCampaignResponse>> {
    return this.http.post<BaseApiResponse<IJoinCampaignResponse>>(environment.apiUrl + `/campaigns/${programID}/join`, params);
  }
}
